export default "__VITE_ASSET__qB7umI2Z__"